import { del, get, post, put } from "../common/apiClient";

const PATH = "/exam-progress";
const createUserExamProgress = async (key, body) => {
  return await post(PATH + `/${key}`, body);
};
const getUserExamProgress = async (key) => {
  return await get(PATH + `/${key}`);
};
const updateUserExamProgressCompleted = async (key) => {
  return await put(PATH + `/${key}/completed`);
};

const deleteUserExamProgress = async (key, body) => {
  return await del(PATH + `/${key}`);
};

// Get all active exam statuses for current user
const getAllUserExamProgress = async () => {
  return await get(PATH);
};

// Clean up expired exam statuses
const cleanupExpiredUserExamProgress = async () => {
  return await del(PATH);
};

// Clean up exam statuses by assessmentId
const cleanupUserExamProgress = async (assessmentId) => {
  return await del(PATH + `/assessment/${assessmentId}`);
};

export {
  createUserExamProgress,
  getUserExamProgress,
  updateUserExamProgressCompleted,
  deleteUserExamProgress,
  getAllUserExamProgress,
  cleanupExpiredUserExamProgress,
  cleanupUserExamProgress,
};
